module.exports = __webpack_public_path__ + "static/media/ic_truck.f0da8773.svg";